export function parseSlackBlocksToHTML(blocks: any[]): string {
  let htmlResult = '';

  blocks.forEach((block) => {
    if (block.type === 'rich_text') {
      block.elements.forEach((section: any) => {
        if (section.type === 'rich_text_section') {
          section.elements.forEach((element: any) => {
            if (element.type === 'text') {
              let textContent = element.text;

              // Apply styles dynamically based on the style object flags
              if (element.style) {
                if (element.style.bold || element.style.Bold)
                  textContent = `<strong>${textContent}</strong>`;
                if (element.style.italic || element.style.Italic)
                  textContent = `<em>${textContent}</em>`;
                if (element.style.strike || element.style.Strike)
                  textContent = `<del>${textContent}</del>`;
                if (element.style.code || element.style.Code)
                  textContent = `<code>${textContent}</code>`;
              }

              htmlResult += textContent;
            } else if (element.type === 'emoji') {
              if (element.unicode) {
                const codePoint = parseInt(element.unicode, 16);
                htmlResult += String.fromCodePoint(codePoint);
              } else {
                htmlResult += `:${element.name}:`;
              }
            }
          });
        }
      });
    }
  });

  return htmlResult;
}
